import React from "react";
import { inject, observer } from "mobx-react";
import HomePageStore from "./HomePageStore";
import {
  VideoBanner,
  QuickLinkers,
  Warranties,
  DiscoverAndBuild,
  SubaruOffer,
  SubaruDifference,
  DealerSection,
  RightHandFlyout,
  HomePageBanner,
} from "./components";

import SubscribeNowPopupContainer from "../../containers/SubscribeNowPopupContainer";
import PromoRibbon from "./components/PromoRibbon";

interface HomePageProps {}

interface InjectedProps extends HomePageProps {
  homePageStore: HomePageStore;
}
interface HomePageState {
  isFlyoutExpanded: boolean;
}

class homePageContent extends React.Component<HomePageProps, HomePageState> {
  constructor(props: HomePageProps) {
    super(props);
    this.state = {
      isFlyoutExpanded: false,
    };
  }

  get injected() {
    return this.props as InjectedProps;
  }

  componentDidMount(): void {
    const { homePageStore } = this.injected;
    homePageStore.fetchHomePageContentData();
    homePageStore.fetchSavedSuburb();
    window.addEventListener("locationSelected", (e: any) =>
      homePageStore.fetchSavedSuburb()
    );
    window.addEventListener("scroll", this.contractWhenRequired);
  }

  componentWillUnmount(): void {
    const { homePageStore } = this.injected;
    window.removeEventListener("locationSelected", (e: any) =>
      homePageStore.fetchSavedSuburb()
    );
    window.removeEventListener("scroll", this.contractWhenRequired);
  }

  expandWhenRequired = () => {
    if (!this.state.isFlyoutExpanded) {
      this.setState({
        isFlyoutExpanded: true,
      });
    }
  };

  contractWhenRequired = () => {
    if (this.state.isFlyoutExpanded) {
      this.setState({
        isFlyoutExpanded: false,
      });
    }
  };

  render() {
    const { homePageStore } = this.injected;

    if (
      !!homePageStore.homePageContent.response &&
      !!homePageStore.homePageContent.response.promoRibbon
    ) {
      const homePage = document.getElementById("homePage");
      if (homePage) {
        document.getElementsByTagName("body")[0].classList.add("has-promoBar");
      }
    }

    return (
      <div className="home_page">
        {homePageStore.homePageContent.response && (
          <div>
            {!!homePageStore.homePageContent.response.promoRibbon && (
              <PromoRibbon />
            )}
            {homePageStore.homePageContent.response.banner.useVideoBanner ? (
              <VideoBanner />
            ) : (
              <HomePageBanner />
            )}
            <QuickLinkers />
            <DiscoverAndBuild />
            <Warranties />
            <SubaruDifference />

            {homePageStore.homePageContent.response.subaruOffers.map(
              (offer, key) => (
                <SubaruOffer key={key} subaruOffer={offer} />
              )
            )}

            <DealerSection />
            <RightHandFlyout
              isActive={this.state.isFlyoutExpanded}
              expandWhenRequired={this.expandWhenRequired}
            />
            <SubscribeNowPopupContainer />
          </div>
        )}
      </div>
    );
  }
}

export default inject("homePageStore")(observer(homePageContent));
